import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import every from 'lodash/every'
import some from 'lodash/some'
import Chip from 'atoms/Chip'
import AddIcon from '@material-ui/icons/Add'
import { EMAIL, TEXT, FIRST_NAME, LAST_NAME, PHONE, WORKFLOWMAX_COMPANY } from 'constants/proposalCustomerFieldTypes'
import { WORKFLOWMAX } from 'constants/proposalFieldTypes'
import { createCustomField } from 'utils/proposals'
import Menu from 'atoms/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import FieldAddDialog from './FieldAddDialog'

const regularFields = [
  { type: EMAIL, label: 'Email' },
  { type: FIRST_NAME, label: 'First name' },
  { type: LAST_NAME, label: 'Last name' },
  { type: PHONE, label: 'Phone' },
  { type: WORKFLOWMAX_COMPANY, label: 'Company name' },
]

export default class CustomerFieldAdd extends Component {
  static propTypes = {
    proposalFields: PropTypes.array.isRequired,
    customerFields: PropTypes.array.isRequired,
    onAdd: PropTypes.func.isRequired,
  }

  state = {
    dialogOpen: false,
    menuAnchorEl: null,
  }

  canAddField = (type) => {
    const { customerFields, proposalFields } = this.props
    if (some(customerFields, { type })) return false
    if (type === WORKFLOWMAX_COMPANY && !some(proposalFields, { type: WORKFLOWMAX })) return false
    return true
  }

  toggleDialog = () => {
    const { dialogOpen } = this.state
    this.setState({ dialogOpen: !dialogOpen })
  }

  toggleMenu = menuAnchorEl => () => {
    this.setState({ menuAnchorEl })
  }

  handleDialogSubmit = (data) => {
    const { onAdd } = this.props
    const field = createCustomField(TEXT, data)
    onAdd(field)
  }

  handleChipClick = (ev) => {
    const { customerFields } = this.props
    const allRegularFieldsExist = every(
      regularFields,
      ({ type }) => some(customerFields, { type })
    )
    if (allRegularFieldsExist) {
      this.toggleDialog()
    } else {
      this.toggleMenu(ev.currentTarget)()
    }
  }

  handleMenuItemClick = type => () => {
    const field = createCustomField(type)
    this.fieldToAddOnMenuExited = field
    this.setState({ menuAnchorEl: null })
  }

  handleMenuExited = () => {
    const { onAdd } = this.props
    if (this.fieldToAddOnMenuExited) {
      onAdd(this.fieldToAddOnMenuExited)
      this.fieldToAddOnMenuExited = null
    }
  }

  handleMenuCustomItemClick = () => {
    this.setState({ menuAnchorEl: null, dialogOpen: true })
  }

  renderMenuItems() {
    return regularFields.map(field => (
      this.canAddField(field.type) && (
        <MenuItem
          key={field.type}
          onClick={this.handleMenuItemClick(field.type)}
        >
          { field.label }
        </MenuItem>
      )
    ))
  }

  render() {
    const { dialogOpen, menuAnchorEl } = this.state
    return (
      <Fragment>
        <FieldAddDialog
          open={dialogOpen}
          onClose={this.toggleDialog}
          onSubmit={this.handleDialogSubmit}
        />
        <Menu
          open={!!menuAnchorEl}
          anchorEl={menuAnchorEl}
          onClose={this.toggleMenu()}
          onExited={this.handleMenuExited}
        >
          { this.renderMenuItems() }
          <MenuItem onClick={this.handleMenuCustomItemClick}>Custom</MenuItem>
        </Menu>
        <Chip
          round
          disablePadding
          icon={AddIcon}
          onClick={this.handleChipClick}
        />
      </Fragment>
    )
  }
}
